import urls from 'constants/urls';

export const getShowFavouritesIcon = (currentPathname: string): boolean => {
  return !currentPathname.startsWith(urls.quickShop);
};
